<template>
  <div id="ligacao">
   <cliente :cliente_id="cliente_id" />
    <div class="row">
      <div class="col-md-5">
        <div class="card card-default">
          <div class="card-body msg_container_base" id="chat">
            <div class="forum" v-for="item in calls" :key="item.id">
              <div class="row msg_container base_receive">
                <div class="col-md-12 col-xs-12">
                  <div class="messages msg_receive">
                    <small
                      ><strong>{{ item.colaborador.name }}</strong></small
                    >
                    <p>
                      {{ item.message }}
                    </p>
                    <p v-if="item.reschedule">
                      <strong
                        >Reagendado para:
                        {{ moment(item.reschedule).format("LLLL") }}</strong
                      >
                    </p>

                    <time>{{
                      moment(item.created_at).format("DD/MM/YYYY HH:mm")
                    }}</time>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <form
              id="form_chat"
              @submit.prevent="submit()"
              class="ajax_off"
              method="post"
              action=""
            >
              <b-button
                variant="outline-secondary mb-2"
                @click="reagendar = !reagendar"
                type="button"
                ><span v-if="!reagendar">Reagendar ligação</span
                ><span v-else>Cancelar Reagendamento</span></b-button
              >

              <div class="form-group" v-if="reagendar">
                <label>Reagendar em (Data e Hora):</label>
                <input
                  class="form-control"
                  type="datetime-local"
                  v-model="call.reschedule"
                />
              </div>

              <div class="form-group">
                <textarea
                  id="btn-input-note"
                  name="descricao"
                  class="form-control input-sm chat_input"
                  autocomplete="off"
                  v-model="call.message"
                  autofocus=""
                  :placeholder="placeholder"
                  required=""
                ></textarea>
              </div>
              <div class="form-group">
                <b-button
                  type="submit"
                  variant="outline-secondary"
                  class="float-right"
                  id="btn-chat"
                >
                  <i class="fa fa-save"></i> Salvar
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <b-card title="Propostas">
          <b-card-text v-for="indicacao in cliente.indicacoes" :key="indicacao.indicacao_id">
           <a :href="`/proposta/get/${indicacao.proposta.proposta_link}`" target="_blank"> {{indicacao.proposta.proposta_id}}</a>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      placeholder: "Descreva a ligação aqui...",
      reagendar: false,
      cliente: {},
      calls: [],
      call: {
        message: "",
        reschedule: null,
      },
    };
  },
  watch: {
    reagendar(newValue, oldValue) {
      this.placeholder = !newValue
        ? "Descreva a ligação aqui..."
        : "Escreva o motivo do reagendamento...";
    },
  },
  computed: {
    ...mapState("ligacao", ["cliente_id","menu_id","item_id"]), 
  },
  created() {
  
    this.getCalls();
  },
  methods: {  
 
    async getCalls() {
      const result = await this.$api.get(
        `alvara/ligacoes/${this.item_id}`
      );
      this.calls = result.data;
    },
    async submit() {
      this.call.menu_id = this.menu_id;
      this.call.item_id = this.item_id;

      const result = await this.$api.post("call", this.call);
      if (result.data.ok) {
        this.call.message = "";
        this.call.reschedule = null;
        this.getCalls();
      }
    },
  },
};
</script>